/* LOCAL REVIEW CANDIDATE ONLY. No self-start, storage, SDK, credentials or consent writes. */
(function (root) {
  'use strict';
  const ORIGIN = 'https://www.herimyst.com';
  const PATH = '/products/marquise-floating-diamond-drop-huggie-earrings';
  const VERSION = 'hm_marquise_views_v2';
  const KEY = '__hmMarquiseProductionV2';
function previewSessionAllowed(win, config) {
  try {
    const url = new URL(win.location.href);
    const theme = win.Shopify?.theme;
    // These runtime metadata fields must be verified on the real preview first.
    // If missing or different, fail closed; query parameters alone are not proof.
    return config.previewOnly === true &&
      /^[0-9]+$/.test(config.expectedPreviewThemeId || "") &&
      String(theme?.id) === config.expectedPreviewThemeId &&
      ["unpublished", "development"].includes(theme?.role) &&
      (!url.searchParams.has("preview_theme_id") ||
        url.searchParams.get("preview_theme_id") === config.expectedPreviewThemeId) &&
      /^[a-f0-9]{32}$/.test(config.qaSessionToken || "") &&
      new URLSearchParams(url.hash.slice(1)).get("hm_qa") === config.qaSessionToken;
  } catch (_) { return false; }
}


  function allowed(win) {
    try {
      const p = win.Shopify?.customerPrivacy;
      return p?.marketingAllowed?.() === true && p?.analyticsProcessingAllowed?.() === true && p?.saleOfDataAllowed?.() === true;
    } catch (_) { return false; }
  }
  // Value provenance: current landing URL only, after permission. Not provider authenticity validation.
  // Conservative local size/character guard, not an OpenAI-documented token grammar.
  function landingOppref(href) {
    try {
      const url = new URL(href);
      if (url.origin !== ORIGIN || url.pathname !== PATH) return '';
      const values = url.searchParams.getAll('oppref');
      if (values.length !== 1) return '';
      const value = values[0];
      return value.length > 0 && value.length <= 1024 && /^[A-Za-z0-9_=-]+$/.test(value) ? value : '';
    } catch (_) { return ''; }
  }
  function install(win, supplied = {}) {
    const config = Object.freeze({ ...supplied });
    const qa = config.mode === 'preview-qa';
    const registryKey = qa ? KEY + 'QA' : KEY;
    if (win[registryKey]) return win[registryKey];
    const doc = win.document;
    const attempted = new Set();
    const records = [];
    let stopped = false, revoked = false, everAllowed = false, privacyLoadAttempted = false, privacyLoadFailed = false, viewId;
    function scope() {
      try {
        const url = new URL(win.location.href), theme = win.Shopify?.theme;
        const realTarget = win === win.top && win.origin === ORIGIN && url.origin === ORIGIN && url.pathname === PATH && win.Shopify?.designMode !== true;
        if (qa) return config.enabled === true && config.qaOnly === true && realTarget &&
          !url.searchParams.has('oppref') && previewSessionAllowed(win, config);
        return config.mode !== 'preview-qa' && config.enabled === true && config.oldMarquiseBrowseCutoverConfirmed === true &&
          /^\d+$/.test(config.expectedPublishedThemeId || '') && String(theme?.id) === config.expectedPublishedThemeId &&
          theme?.role === 'main' && realTarget && !url.searchParams.has('preview_theme_id') &&
          !url.searchParams.has('_fd') && !new URLSearchParams(url.hash.slice(1)).has('hm_qa');
      } catch (_) { return false; }
    }
    function permission() {
      if (!allowed(win)) {
        if (everAllowed) revoked = true; // Terminal for this document; no delayed replay after withdrawal.
        return false;
      }
      if (revoked) return false;
      everAllowed = true;
      return true;
    }
    function sourceAllowed() {
      // Never override an already stricter document or meta policy.
      const policies = [doc.referrerPolicy || ''];
      for (const node of doc.querySelectorAll?.('meta[name="referrer" i]') || []) policies.push(node.content || '');
      return !policies.some(p => ['no-referrer', 'same-origin', 'never'].includes(p.trim().toLowerCase()));
    }
    function ready() {
      return !stopped && !revoked && !privacyLoadFailed && scope() && permission() &&
        doc.readyState !== 'loading' && doc.visibilityState === 'visible' && doc.prerendering !== true &&
        sourceAllowed() && typeof win.crypto?.randomUUID === 'function';
    }
    function run() {
      if (!ready()) return;
      if (!viewId) viewId = win.crypto.randomUUID();
      for (const event of ['page_viewed', 'contents_viewed']) {
        if (!ready()) break;
        if (attempted.has(event)) continue;
        const params = new URLSearchParams({pid:'Gvw9qHh1xGVjuNpiNBkSCZ', event,
          event_id:`${qa ? "qa_production_v2" : VERSION}_${event}_${viewId}`, 'data[type]':'contents'});
        if (event === 'contents_viewed') params.set('data[contents]', JSON.stringify([{id:'9080678187227',content_type:'product',quantity:1}]));
        // No retained attribution cache; do not inspect other query fields/cookies/storage.
        const oppref = qa ? '' : landingOppref(win.location.href);
        if (oppref) params.set('oppref', oppref);
        if (!ready()) break;
        attempted.add(event); // Reserve before dispatch. Opaque/failing transport is never retried.
        const record = {event, status:'attempted-not-confirmed'};
        records.push(record);
        try {
          Promise.resolve(win.fetch('https://bzr.openai.com/v1/sdk/events?' + params, {
            method:'GET', mode:'no-cors', credentials:'omit', keepalive:true, referrerPolicy:'strict-origin'
          })).then(() => {record.status='opaque-response-not-receipt-proof';}, () => {record.status='transport-failed-no-retry';});
        } catch (_) { record.status='transport-failed-no-retry'; }
      }
    }
    function initialize() {
      if (stopped || !scope()) return;
      if (win.Shopify?.customerPrivacy) { run(); return; }
      if (privacyLoadAttempted || typeof win.Shopify?.loadFeatures !== 'function') return;
      privacyLoadAttempted = true;
      try {
        win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
          if (stopped) return;
          if (error) { privacyLoadFailed = true; return; }
          run();
        });
      } catch (_) { privacyLoadFailed = true; }
    }
    function consentChanged() { if (!stopped) { permission(); initialize(); } }
    function stop() {
      stopped = true;
      doc.removeEventListener('DOMContentLoaded', initialize);
      doc.removeEventListener('visitorConsentCollected', consentChanged);
      doc.removeEventListener('visibilitychange', run);
      win.removeEventListener('load', initialize);
      win.removeEventListener('pagehide', stop);
    }
    const handle = {stop, snapshot:()=>({stopped,revoked,privacyLoadFailed,attempted:attempted.size,records:records.map(r=>({...r}))})};
    win[registryKey] = handle;
    if (config.enabled !== true) return handle;
    doc.addEventListener('DOMContentLoaded', initialize);
    doc.addEventListener('visitorConsentCollected', consentChanged);
    doc.addEventListener('visibilitychange', run);
    win.addEventListener('load', initialize);
    win.addEventListener('pagehide', stop); // No bfcache replay. New document = new visit.
    initialize();
    return handle;
  }
  if (typeof module !== 'undefined') module.exports = {install, landingOppref, previewSessionAllowed};
  else { root.HERIMYSTInstallMarquiseProductionV2 = install; root.HERIMYSTMarquiseProductionPreviewAllowed = previewSessionAllowed; }
})(typeof window !== 'undefined' ? window : undefined);
